<template>
  <div>
    <login-ctrl :propsList="propsList" @forgetTextClick="forgetTextClick" @loginButtonClick="loginButtonClick" @experienceClick="experienceClick" @registerTextClick="registerTextClick"></login-ctrl>
  </div>
</template>
<script>
import LoginCtrl from '../Ctrl/LoginCtrl.vue'
import { LoginLogic } from '../../Logic/LoginLogic.js'
export default {
  props: {
    propsList: {
      type: Object
    }
  },
  components: { LoginCtrl },
  methods: {
    forgetTextClick () {
      this.$emit('forgetTextClick')
    },
    loginButtonClick (value) {
      LoginLogic.login(value.username, value.password)
        .then(resData => {
          this.$emit('loginSuccess', resData)
        }).catch(err => {
          this.$emit('loginFailed', err)
        })
    },
    experienceClick () {
      this.$message('体验账号')
    },
    registerTextClick () {
      this.$emit('registerTextClick')
    }
  }
}
</script>



// WEBPACK FOOTER //
// third_party/common_app/LoginModule/View/Area/LoginArea.vue